import { Button as GddsButon, FormField } from '@geberit/gdds';
import React from 'react';

// styles
import styles from './voucher-display.module.scss';

// types
import type { Voucher } from 'utils/hooks/useVoucher';

// components
import { Translation } from 'components/Translation/Translation';
import { VoucherProps } from 'components/checkout/components/voucher/voucher';
import { VoucherControl } from 'components/voucher-control/voucher-control';

// utils
import { useTranslationFunction } from 'utils/hooks/use-translations';
import { isEmpty } from 'utils/is-empty';
import { useXy } from 'utils/hooks/use-xy';

export type VoucherFormProps = Pick<
  Voucher,
  'applyVoucher' | 'removeVoucher' | 'handleVoucherInputChange' | 'appliedVoucher' | 'voucherCode'
> &
  Pick<VoucherProps, 'displayOnly'>;

export const VoucherDisplay: React.FC<VoucherFormProps> = ({
  voucherCode,
  handleVoucherInputChange,
  applyVoucher,
  appliedVoucher,
  removeVoucher,
  displayOnly,
}) => {
  const translate = useTranslationFunction();
  const hasAppliedVoucher: boolean = !isEmpty(appliedVoucher);
  const isXy = useXy();

  const onFormSubmit: React.FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    applyVoucher();
  };

  const VoucherInput = (
    <div className={styles.voucherInput}>
      <FormField
        name="voucherCode"
        placeholder={translate('web20_checkout_voucher_placeholder')}
        values={{ voucherCode: voucherCode.toUpperCase() }}
        onChange={handleVoucherInputChange}
      />
    </div>
  );

  const VoucherLabel = (
    <div className={styles.voucherLabel}>
      <Translation id="web20_checkout_voucher_title" />
    </div>
  );

  if (displayOnly) {
    if (!hasAppliedVoucher) return null;

    return (
      <div className={styles.voucherDisplay}>
        {VoucherLabel}
        {<VoucherControl {...{ appliedVoucher: appliedVoucher!, removeVoucher, displayOnly }} />}
      </div>
    );
  }

  return (
    <div className={styles.voucherDisplay}>
      {VoucherLabel}
      <form className={styles.voucherForm} onSubmit={onFormSubmit}>
        {hasAppliedVoucher ? (
          <VoucherControl {...{ appliedVoucher: appliedVoucher!, removeVoucher, displayOnly }} />
        ) : (
          VoucherInput
        )}
        {isXy ? (
          <>
            <GddsButon
              disabled={hasAppliedVoucher}
              className={styles.voucherSubmitButton}
              buttonType='submit'
            >
              <Translation id="web20_checkout_voucher_activate" />
            </GddsButon>
          </>
        ):(
          <>
            <button type="submit" className={styles.voucherSubmitButton} disabled={hasAppliedVoucher}>
              <Translation id="web20_checkout_voucher_activate" />
            </button>
          </>
        )}
      </form>
    </div>
  );
};
